import React from 'react';

const Manager = ({ manager }) => {
  return (
    <div className="flex mt-2 items-center">
      <div className="w-1/4">
        <img
          className="h-16 w-16 rounded-full object-cover"
          src={manager.photoUrl}
          alt={`${manager.firstName} ${manager.lastName}`}
        />
      </div>
      <div className="w-3/4">
        <div className="flex">
          <div className="w-1/2">
            <div className="bg-cf-100 py-2 px-2 rounded text-center h-32">
              <p className="text-sm font-bold">Meet {manager.firstName}</p>
              <p className="leading-none">Your assigned Farm Manager</p>
              <p className="leading-none mt-2">
                {manager.firstName} is an Agronomist with {manager.experience} year(s) experience in
                the agricultural sector.
              </p>
            </div>
          </div>
          <div className="w-1/2">
            <div className="bg-gray-100 py-1 px-2 rounded">
              <p className="text-sm font-bold mb-2">{manager.firstName}'s Experience</p>
              {manager.crops.map(crop => (
                <div className="flex" key={crop.name}>
                  <div className="rounded-full h-6 w-6 bg-gray-300"></div>
                  <div className="ml-2">
                    <p>{crop.name}</p>
                    <div className={`border-b-4 border-cf-300 w-20`}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manager;
